import { HourglassEmptyOutlined, DoneOutlined, HourglassDisabledOutlined, CancelOutlined } from "@mui/icons-material";
import { Chip, Stack, Typography } from "@mui/material";
import React from "react";
import { ExternalAccessStatus } from "../../../Core/Api/Types/access-models";

function getIconAndColor(status: ExternalAccessStatus) {
  switch (status) {
    case ExternalAccessStatus.Pending:
      return { icon: <HourglassEmptyOutlined color="disabled" />, color: "text.tier" };
    case ExternalAccessStatus.Active:
      return { icon: <DoneOutlined color="primary" />, color: "primary" };
    case ExternalAccessStatus.Expired:
      return { icon: <HourglassDisabledOutlined color="error" />, color: "error" };
    case ExternalAccessStatus.Revoked:
      return { icon: <CancelOutlined color="error" />, color: "error" };
  }
}

export const ExternalAccessStatusTableCell = (props: { status: ExternalAccessStatus }) => {
  const { status } = props;

  const { icon, color } = getIconAndColor(status);

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      {icon}
      <Typography variant="body1" color={color}>
        {status}
      </Typography>
    </Stack>
  );
};

export const ExternalAccessStatusDetailsChip = (props: { status: ExternalAccessStatus }) => {
  const { status } = props;

  const { icon, color: _color } = getIconAndColor(status);
  const color = React.useMemo(() => {
    if (_color === "primary") return "primary";
    if (_color === "error") return "error";
    return "default";
  }, [_color]);

  return <Chip icon={icon} label={status} color={color} variant="outlined" />;
};
